var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"background--views"},[_c('v-container',[_c('RolesTable',{attrs:{"updated":_vm.updated,"name":"RolesTable"},on:{"updateRole":_vm.updateRole,"updatedComplete":function($event){_vm.updated = false}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }